import { render } from "./FacturasPorReceptor.vue?vue&type=template&id=763f7bb8&scoped=true"
import script from "./FacturasPorReceptor.vue?vue&type=script&lang=ts"
export * from "./FacturasPorReceptor.vue?vue&type=script&lang=ts"

import "./FacturasPorReceptor.vue?vue&type=style&index=0&id=763f7bb8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-763f7bb8"

export default script